import { apiPost } from '../api';
import { ApiNames, ApiPath } from '../enums';

import { UserSignUpRequest, UserSignUpResponse } from './model';

export async function signUp(body: UserSignUpRequest): Promise<UserSignUpResponse> {
  return apiPost<UserSignUpResponse, UserSignUpRequest>(ApiNames.MonorepoApiEndpoint, ApiPath.UserSignUp, body, false);
}
